import { FormattedMessage } from 'react-intl'

import type { InvoiceDetailsProps } from 'Modules/purchase/components/StripeInvoiceDetails/StripeInvoideDetails.types'

import { Heading } from 'Components/_theme'

export const StripeInvoiceDetails = (props: InvoiceDetailsProps) => {
  const { invoiceData = {} } = props

  const hasAnyAddressElement =
    !!invoiceData?.address?.line1 ||
    !!invoiceData?.address?.line2 ||
    !!invoiceData?.address?.postal_code ||
    !!invoiceData?.address?.city ||
    !!invoiceData?.address?.country

  const hasAnyInfo =
    !!invoiceData?.customer_name ||
    !!invoiceData?.customer_email ||
    hasAnyAddressElement

  if (!hasAnyInfo) {
    return null
  }

  return (
    <div className="invoiceDetails" data-testid="invoice-details">
      <Heading as={5} className="mb-4" size={5}>
        <FormattedMessage id="OfferPaymentForm_billing_details" />
      </Heading>

      {!!invoiceData?.customer_name && (
        <div className="addressName">{invoiceData.customer_name}</div>
      )}

      {!!invoiceData?.customer_email && <div>{invoiceData.customer_email}</div>}

      {hasAnyAddressElement && (
        <div className="addressBlock">
          {!!invoiceData.address?.line1 && (
            <div>{invoiceData.address.line1}</div>
          )}

          {!!invoiceData.address?.line2 && (
            <div>{invoiceData.address.line2}</div>
          )}

          <div>
            {!!invoiceData.address?.postal_code && (
              <span>{invoiceData.address.postal_code}</span>
            )}

            {!!invoiceData.address?.city && (
              <span>
                {!!invoiceData.address?.postal_code && ' '}
                {invoiceData.address.city}
              </span>
            )}

            {!!invoiceData.address?.country && (
              <span>
                {(!!invoiceData.address?.postal_code ||
                  !!invoiceData.address?.city) &&
                  ', '}
                {invoiceData.address.country}
              </span>
            )}
          </div>
        </div>
      )}
    </div>
  )
}
